import * as React from 'react';
import { useState } from 'react';
import Tooltip from '../Core/Tooltip';
import '../../styles/components/colour-swatch.scss';

export interface ColourSwatchProps {
    title: string;
    value: string;
    index?: number;
    selected?: boolean;
    available: boolean;
    swatchImage?: string | null;
    href?: string;
    outOfStockTitle?: string
    outOfStockMessage?: string
    onClick: (value:string) => void;
}

const ColourSwatch = (props: ColourSwatchProps) => {
    const [tooltipVisible, setTooltipVisible] = useState(false);
    const {selected, available, title, onClick, swatchImage, outOfStockTitle, outOfStockMessage } = props;
    const handle = title.replace(' ', '-').toLowerCase();
    const handleClick = (value: string) => {
        if (available) {
          onClick(value);
        }
      };
      const ShowTooltip = () => {
        setTooltipVisible(true);
      }
      const HideTooltip = () => {
        setTooltipVisible(false);
      }
      let style = {};
      if (swatchImage) {
        style = {
          backgroundImage: `url(${swatchImage})`
        };
      }
      return (
        <div className={`colour-swatch-wrapper ${ !available ? 'colour-swatch-wrapper--disabled' : '' }`}
        onMouseOver={ () => ShowTooltip() }
        onMouseOut={ () => HideTooltip() }>
          { !available && <Tooltip title={ outOfStockTitle ? outOfStockTitle : "Sorry, this is out of stock"} message={ outOfStockMessage ? outOfStockMessage :"Please check back soon"} open={ tooltipVisible } /> }
          <button type="button" className={ 'colour-swatch colour-swatch--' + handle + ' ' + (selected === true ? ' selected' : '') + (available === true ? ' available' : ' out-of-stock') }
          onClick={ () => handleClick(props.value)}
          title={ title }
          style={style}
          disabled={!available}
          ></button>
        </div>
      );
}
export default ColourSwatch;
